/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface ZeroMeasurementParametersDto
 */
export interface ZeroMeasurementParametersDto {
    /**
     * 
     * @type {number}
     * @memberof ZeroMeasurementParametersDto
     */
    zeroMeasurementValidityDuration?: number;
    /**
     * 
     * @type {number}
     * @memberof ZeroMeasurementParametersDto
     */
    zeroMeasurementDuration?: number;
    /**
     * 
     * @type {string}
     * @memberof ZeroMeasurementParametersDto
     */
    $type?: ZeroMeasurementParametersDtoTypeEnum;
}


/**
 * @export
 */
export const ZeroMeasurementParametersDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedDeviceComponentDtoZeroMeasurementParametersDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.DeviceComponent.Dto.ZeroMeasurementParametersDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type ZeroMeasurementParametersDtoTypeEnum = typeof ZeroMeasurementParametersDtoTypeEnum[keyof typeof ZeroMeasurementParametersDtoTypeEnum];



/**
 * Check if a given object implements the ZeroMeasurementParametersDto interface.
 */
export function instanceOfZeroMeasurementParametersDto(value?: unknown): value is ZeroMeasurementParametersDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(ZeroMeasurementParametersDtoTypeEnum)[0];
}

export function ZeroMeasurementParametersDtoFromJSON(json: any): ZeroMeasurementParametersDto {
    return ZeroMeasurementParametersDtoFromJSONTyped(json, false);
}

export function ZeroMeasurementParametersDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ZeroMeasurementParametersDto {
    if (json == null) {
        return json;
    }
    return {
        
        'zeroMeasurementValidityDuration': json['zeroMeasurementValidityDuration'] == null ? undefined : json['zeroMeasurementValidityDuration'],
        'zeroMeasurementDuration': json['zeroMeasurementDuration'] == null ? undefined : json['zeroMeasurementDuration'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function ZeroMeasurementParametersDtoToJSON(value?: ZeroMeasurementParametersDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'zeroMeasurementValidityDuration': value['zeroMeasurementValidityDuration'],
        'zeroMeasurementDuration': value['zeroMeasurementDuration'],
        '$type': value['$type'],
    });
}

